import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';

const cookies = new Cookies();

class IdentityEmailReset extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  Base64EncodeUrl(str){
    return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  componentDidMount() {
    const crypto = require('crypto');
    const plaintext = crypto.randomBytes(30).toString('base64').slice(0, 30);
    const hash = encodeURIComponent(this.Base64EncodeUrl(crypto.createHash("sha256").update(plaintext).digest("base64")));
    const scope = 'user';
    const redirect = '/reset-email';
    let useRedirect = encodeURIComponent(redirect);
    if (this.props.location.search) {
      useRedirect = encodeURIComponent(redirect + this.props.location.search);
    }

    cookies.set('_vtotmp', plaintext, { host: process.env.HOSTNAME, path: '/' });

    window.location.href = process.env.REACT_APP_API_URL + '/auth/provider?code_challenge=' + hash + '&scope=' + scope + '&callerUrl=' + useRedirect;
  }

  render() {
    return (
      <Loader />
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(IdentityEmailReset));
